<h2 mat-dialog-title>Zmiana copywritera</h2>

<mat-dialog-content>
  <div *ngIf="order">
  <p>Zlecenie aktualnie przypisane do: <b>{{order.copywriterName}}</b></p>
  </div>

  <div *ngIf="!order">
    <p>Hurtowe przepisywanie zleceń do nowego copywritera</p>
  </div>

  <p>Wybierz z listy do kogo zlecenie ma zostać przypisane:</p>
  <form [formGroup]="editForm" class="full-width-container">

  <mat-form-field class="full-width-container">
    <input type="text" matInput placeholder="Copywriter" formControlName="copywriterGroup"
           [matAutocomplete]="autoGroup" class="full-width-container">
    <mat-autocomplete #autoGroup="matAutocomplete" class="full-width-container">
      <mat-optgroup *ngFor="let group of copywriterGroupOptions | async" [label]="group.letter">
        <mat-option *ngFor="let name of group.names" [value]="name.name" (click)="setCopywriterId(name.id)">
          {{name.name}}
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
  </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Anuluj</button>
  <button mat-button primary cdkFocusInitial id="saveBtn" [disabled]="inProgress" (click)="save()">Zapisz</button>
</mat-dialog-actions>
